
export const getLocalStorageValue = <T>(key: string, defaultValue: T): T => {
  const storedValue = localStorage.getItem(key)

  if (storedValue) {
    return JSON.parse(storedValue)
  }

  return defaultValue
}

export const setLocalStorageValue = <T>(key: string, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value))
}
